import { LtlPipelineViewModel } from "../../../../../../ViewModel/LtlPipelineViewModel";
import { isFirstLtlRoute } from "./IsFirstLtlRoute";
import { isPdsr } from "../../../IsPdsr";

export function getStartDestinationGsdb(ltlPipeline: LtlPipelineViewModel) {
  if (isPdsr(ltlPipeline) && ltlPipeline?.routing?.length === 0) {
    return ltlPipeline?.PlantGsdb || "";
  }

  if (isFirstLtlRoute(ltlPipeline)) {
    return ltlPipeline.SupplierGsdb || "";
  }

  const routing = ltlPipeline.routing || [];
  const lastRouting = routing[routing.length - 1];
  return lastRouting.NextDestinationGsdb;
}
